
// In a perfect world, Subscription should be an entity object (hexa architecture).
// For now, this is just the helper to avoid code duplication.

export default {

    isSpoum: (subscription) => {
        return subscription && parseFloat(subscription.spoumConfidence) > 0.5
    }

}